import React from 'react';

import { Box, Grid, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import { Card } from 'components/UI';
import { useStyles } from './Common.styled';

export const ReservationRulesetDetailsWidget = ({ reservationRuleset, loading }) => {
  const classes = useStyles();
  return (
    <Card title={i18n.t('common.details')} cardProps={{ style: { height: '100%' } }}>
      <Box>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h3">
              <div className={classes.cardDetails}>
                <span className={classes.cardDetailsTitle}>{i18n.t('common.name')}:</span>
                <span>
                  <b>{reservationRuleset?.name}</b>
                </span>
              </div>
              <div className={classes.cardDetails}>
                <span className={classes.cardDetailsTitle}>{i18n.t('common.app_order')}:</span>
                <span>
                  <b>{reservationRuleset?.view_order}</b>
                </span>
              </div>
              <div className={classes.cardDetails}>
                <span className={classes.cardDetailsTitle}>{i18n.t('common.description')}:</span>
                <span>{reservationRuleset?.description || '--'}</span>
              </div>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};
